/**
 * Dropdown filter to display ravens of only the active selected statuses
 * Statuses: Driving, Parked/Idle, Offline/Unplugged
 * Rendered in GridPage.js
 */

import React from 'react';
import PropTypes from 'prop-types';
import './StatusFilter.scss'
import { strings } from '../../../localization';
import SelectDropDown from '../../common/SelectDropDown';

const STATUSES = [
    { key: 'driving', label: strings.raven_status_driving },
    { key: 'parked', label: strings.raven_status_parked },
    { key: 'offline', label: strings.raven_status_offline }
];

export default class StatusFilter extends React.PureComponent {

    handleChange = (index) => {
        const status = STATUSES[index];
        this.props.onToggle(status.key);
    }

    handleSetAll = (selectAll) => {
        STATUSES.forEach(status => {
            const isCurrentlySelected = this.props.statusFilter.has(status.key);
            if (selectAll && !isCurrentlySelected) {
                this.props.onToggle(status.key);
            } else if (!selectAll && isCurrentlySelected) {
                this.props.onToggle(status.key);
            }
        });
    }

    render() {
        const { statusFilter } = this.props;

        const options = STATUSES.map(status => ({
            label: status.label,
            value: status.key,
            checked: statusFilter.has(status.key)
        }));

        return (
            <div>
                <h5 className='filter-by-status-header'>
                    {strings.filter_by_status}
                </h5>
                <div className="checkbox-filters">
                    <button
                        className="btn btn-sm"
                        onClick={() => this.handleSetAll(true)}
                    >
                        {strings.action_select_all}
                    </button>
                    <button
                        className="btn btn-sm"
                        onClick={() => this.handleSetAll(false)}
                    >
                        {strings.action_select_none}
                    </button>
                </div>
                <div className='status-filter'>
                    <SelectDropDown
                        for="status-filter"
                        options={options}
                        onChange={this.handleChange}
                        onSetAll={this.handleSetAll}
                        enableFilter={false}
                        enableSearch={false}
                        isDefaultOptional={true}
                        isDefaultSelectAll={true}
                        nameEmbeddedSelectBox={strings.filter_by_status}
                    />
                </div>
            </div>
        );
    }
}

StatusFilter.propTypes = {
    statusFilter: PropTypes.instanceOf(Set).isRequired,
    onToggle: PropTypes.func.isRequired
};